import { general } from "./en/general";
import { onelink } from "./en/onelink";
import { editor } from "./en/editor";
import { stats } from "./en/stats";
import { account } from "./en/account";
import { myaccount } from "./en/myaccount";
import { payment } from "./en/payment";
import { auth } from "./en/auth";
import { topmenu } from "./en/topmenu";
import { plans } from "./en/plans";
import { user } from "./en/user";
import { access } from "./en/access";
import { validator } from "./en/validator";
import { legal } from "./en/legal";
import { footer } from "./en/footer";

export const lang = {
  general,
  onelink,
  editor,
  stats,
  account,
  myaccount,
  payment,
  auth,
  topmenu,
  plans,
  user,
  access,
  validator,
  legal,
  footer,
};
